import initEventCalendarMonth from './event-calendar'
import fetchTimezones from './timezones'

initEventCalendarMonth()
fetchTimezones()
